import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getDoneWorksOperationalMaterials(companyId, doneWorkId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS,
		dtConfig[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].getDoneWorksOperationalMaterials,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
			},
		},
	)
}
function getDoneWorksOperationalMaterialPreview(companyId, doneWorkId, operationalMaterialId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS,
		dtConfig[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].getDoneWorksOperationalMaterialPreview,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
				operationalMaterialId,
			},
		},
	)
}
function getDoneWorksOperationalMaterialPopup(companyId, doneWorkId, operationalMaterialId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS,
		dtConfig[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].getDoneWorksOperationalMaterialPopup,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
				operationalMaterialId,
			},
		},
	)
}

function createDoneWorksOperationalMaterial(companyId, doneWorkId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS,dtConfig[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].createDoneWorksOperationalMaterial, {
		urlParams: {
			companyId,
			doneWorkId,
		},
		...data,
	})
}

function getDoneWorksOperationalMaterial(companyId, doneWorkId, operationalMaterialId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS,dtConfig[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].getDoneWorksOperationalMaterial, {
		urlParams: {
			companyId,
			doneWorkId,
			operationalMaterialId,
		},
	})
}

function patchDoneWorksOperationalMaterial(companyId, doneWorkId, operationalMaterialId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS,dtConfig[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].patchDoneWorksOperationalMaterial, {
		urlParams: {
			companyId,
			doneWorkId,
			operationalMaterialId,
		},
		...data,
	})
}

function putDoneWorksOperationalMaterial(companyId, doneWorkId, operationalMaterialId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS,dtConfig[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].putDoneWorksOperationalMaterial, {
		urlParams: {
			companyId,
			doneWorkId,
			operationalMaterialId,
		},
		...data,
	})
}

function deleteDoneWorksOperationalMaterial(companyId, doneWorkId, operationalMaterialId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS,dtConfig[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS].deleteDoneWorksOperationalMaterial, {
		urlParams: {
			companyId,
			doneWorkId,
			operationalMaterialId,
		},
	})
}

export default {
	getDoneWorksOperationalMaterials,
	getDoneWorksOperationalMaterialPopup,
	getDoneWorksOperationalMaterialPreview,
	getDoneWorksOperationalMaterial,
	patchDoneWorksOperationalMaterial,
	putDoneWorksOperationalMaterial,
	createDoneWorksOperationalMaterial,
	deleteDoneWorksOperationalMaterial,
}
